import { useEffect, useState } from 'react';
import { ReactComponent as Playicon } from '../../../assets/Playicon.svg';
import { ReactComponent as Appstore } from '../../../assets/appstore.svg';
import './Dashboard.css';
import RightArrow from '../../../assets/RightArrow.svg';
import { Pagination } from '@mui/material';
import {
  Box,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Typography,
  Grid,
  useMediaQuery,
} from '@mui/material';
import { styled } from '@mui/system';
import { getDashboard } from '../../../services/NetworkServices';
import ConsumerDashboardHeader from '../ConsumerDashboardHeader/ConsumerDashboardHeader';
import StyledBgContainer from '../../../components/StyledBgContainer/StyledBgContainer';
import LeftArrow from '../../../assets/Left 1.svg';
import { getStage } from '../../../services/NetworkServices';
import { storeStageNumber } from '../../../utils/auth-token-utils/cookie';
import { useNavigate } from 'react-router-dom';

const Herobackground = require('../../../assets/hero-section-background.png');
const Herobg2 = require('../../../assets/herobg2.png');
const Phone1 = require('../../../assets/phone1.png');
const Phone2 = require('../../../assets/phone2.png');

interface Transaction {
  id: number;
  paymentDate: string;
  createdAt: string;
  stripeInvoiceId: string;
  lines: {
    description: string;
  };
  amountInDollars: number;
}

// Styled components for alternating row colors
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: 'rgba(96, 111, 140, 0.08)', // Black background for odd rows
    color: 'white',
  },
  '&:nth-of-type(even)': {
    backgroundColor: 'rgba(96, 111, 140, 0.18)', // Grey background for even rows
  },
}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  borderRight: '1px solid rgba(96, 111, 140, 0.15)',
  borderBottom: 'none',
  color: 'white',
}));

const ConsumerDashboard = () => {
  const [transactionList, setTransactionList] = useState<any[]>([]);
  const isSmallScreen = useMediaQuery('(max-width:600px)');
  const [currentPage, setCurrentPage] = useState<number>(1); // Start on page 1
  const itemsPerPage = 5;
  const [totalRecords, setTotalRecords] = useState<number>(0);

  const fetchDashboardDetails = async (page: number, limit: number) => {
    try {
      const response = await getDashboard(page, limit);
      const data = await response.data;

      setTotalRecords(data.data.totalCount);

      const transactionsWithId = data.data.paginatedResults.map(
        (item: Omit<Transaction, 'id'>, index: number) => ({
          id: index + 1 + (page - 1) * limit,
          ...item,
        }),
      );

      const filteredTransactionList = transactionsWithId.map(
        (transaction: Transaction) => ({
          id: transaction.id,
          date: transaction.paymentDate,
          time: new Date(transaction.createdAt).toLocaleTimeString('en-US', {
            timeZone: 'America/New_York',
            hour12: true,
            hour: 'numeric',
            minute: 'numeric',
          }),
          transactionId: transaction.stripeInvoiceId,
          category: transaction.lines.description.includes('$10.00 / month')
            ? transaction.lines.description.slice(4)
            : transaction.lines.description,
          amount: `$ ${transaction.amountInDollars}`,
        }),
      );

      setTransactionList(filteredTransactionList);
    } catch (error) {
      console.error('Error fetching dashboard details:', error);
    }
  };

  const navigate = useNavigate();

  useEffect(() => {
    const fetchStageDetails = async () => {
      try {
        console.log('inside use effect');
        const response = await getStage();
        const data = await response.data;
        if (data) {
          console.log('stage is', data.data.stage);
          const stage = data.data.stage;
          storeStageNumber(stage);
          if (stage === '1') {
            navigate('/participant/createProfile');
          }
          if (stage === '2') {
            navigate('/participant/inviteBabysitter');
          }
          if (stage === '3') {
            navigate('/participant/selectplan');
          }
        }
      } catch (error) {
        console.error('Error fetching profile details:', error);
      }
    };
    fetchStageDetails();
  }, [navigate]);

  useEffect(() => {
    fetchDashboardDetails(currentPage, itemsPerPage); // Fetch data when the page changes
  }, [currentPage]);

  console.log('transaction list is : ', transactionList);

  const handleNextPage = () => {
    setCurrentPage((prev) => prev + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const paginationCount =
    transactionList.length % itemsPerPage === 0
      ? transactionList.length / itemsPerPage
      : Math.floor(transactionList.length / itemsPerPage) + 1;

  return (
    <StyledBgContainer>
      <Container maxWidth="xl" sx={{ px: '54px !important' }}>
        <Box sx={{ padding: isSmallScreen ? '16px' : '32px' }}>
          <ConsumerDashboardHeader />
          <Box
            sx={{
              backgroundImage: {
                xs: `linear-gradient(90deg, rgba(54, 95, 145, 1), rgba(0, 2, 18, 0))`, // Keep only the gradient on xs and sm
                sm: `linear-gradient(90deg, rgba(54, 95, 145, 1), rgba(0, 2, 18, 0))`,
                md: `linear-gradient(90deg, rgba(54, 95, 145, 1), rgba(0, 2, 18, 0)), url(${Herobackground}), url(${Herobg2})`,
              },
              backgroundSize: {
                xs: 'auto', // Adjust as needed for xs and sm
                md: 'contain', // Set for md and larger
              },
              backgroundPosition: 'right',
              backgroundRepeat: 'no-repeat',
              padding: { xs: '16px', md: '32px' },
              borderRadius: '20px',
              marginTop: '16px',
              border: '1px solid rgba(58, 70, 91, 1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              height: { xs: 'auto', md: '250px' },
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            <Grid container alignItems="center" spacing={2}>
              <Grid item xs={12} md={6}>
                <Typography
                  variant="h4"
                  sx={{
                    color: 'white',
                    fontWeight: 'bold',
                    mb: 2,
                    whiteSpace: 'normal',
                    lineHeight: 1.2,
                    fontSize: { xs: '24px', md: '32px', lg: '42px' },
                    textAlign: 'left',
                  }}
                >
                  Download <br /> Mobile Application
                </Typography>
                <Typography
                  sx={{
                    fontWeight: '400',
                    color: 'rgba(255, 255, 255, 0.7)',
                    mb: 2,
                    textAlign: 'left',
                    fontSize: { xs: '14px', md: '12px', lg: '16px' },
                  }}
                >
                  To continue utilizing our consumer services seamlessly,
                  <br /> please download the mobile app.
                </Typography>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'start',
                    flexDirection: { xs: 'column', sm: 'row' },
                    gap: { xs: '20px', sm: '0px' },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      padding: '16px 20px',
                      boxShadow: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.14)',
                      color: 'white',
                      mr: 2,
                      textTransform: 'none',
                      borderRadius: '33px',
                      px: { xs: 2, md: 3 },
                      py: { xs: 0.5, md: 1 },
                    }}
                    endIcon={<Appstore />}
                  >
                    Download For IOS
                  </Button>
                  <Button
                    variant="contained"
                    sx={{
                      padding: '16px 20px',
                      boxShadow: 'none',
                      backgroundColor: 'rgba(255, 255, 255, 0.14)',
                      color: 'white',
                      textTransform: 'none',
                      borderRadius: '33px',
                      px: { xs: 2, md: 3 },
                      py: { xs: 0.5, md: 1 },
                    }}
                    endIcon={<Playicon />}
                  >
                    Download For Android
                  </Button>
                </Box>
              </Grid>

              {/* iPhone images */}
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: { xs: 'none', sm: 'none', md: 'flex' },
                  justifyContent: { xs: 'center', sm: 'end', md: 'end' },
                  alignItems: 'center',
                  position: 'relative',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: { xs: 'row', sm: 'row', md: 'row' },
                    alignItems: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src={Phone1}
                    alt="App Preview 1"
                    sx={{
                      width: { xs: '180px', md: '200px' },
                      height: { xs: '300px', md: '260px' },
                      maxWidth: '100%', // Ensure it stays within the parent container
                      maxHeight: '100%',
                    }}
                  />
                  <Box
                    component="img"
                    src={Phone2}
                    alt="App Preview 2"
                    sx={{
                      width: { xs: '150px', md: '160px' },
                      height: { xs: '250px', md: '260px' },
                      maxWidth: '100%', // Ensure it stays within the parent container
                      maxHeight: '100%',
                      mt: { xs: '16px', md: '50px' },
                      ml: { xs: 0, md: '-20px' },
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>

          <Box
            sx={{ mt: '16px', mb: '16px', display: 'flex', textAlign: 'start' }}
          >
            <Typography
              variant="h5"
              sx={{
                color: 'white !important',
                fontWeight: '700',
                fontFamily: 'Opensans',
              }}
            >
              Payment History
            </Typography>
          </Box>

          {/* Payment History Section */}
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                background: `linear-gradient(rgb(23, 24, 30), rgb(29, 31, 41)) padding-box,
                  linear-gradient(180deg, #365f91 -4.29%, rgba(54, 95, 145, 0) 100%) border-box`,
                border: '2px solid transparent',
                borderRadius: '10px',
              }}
            >
              <Table aria-label="payment history table">
                <TableHead>
                  <TableRow
                    sx={{
                      backgroundColor: 'rgba(96, 111, 140, 0.18)',
                      color: 'white !important',
                    }}
                  >
                    <StyledTableCell>#</StyledTableCell>
                    <StyledTableCell>Date</StyledTableCell>
                    <StyledTableCell>Time</StyledTableCell>
                    <StyledTableCell>Transaction ID</StyledTableCell>
                    <StyledTableCell>Category</StyledTableCell>
                    <StyledTableCell>Amount</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transactionList.map((transaction) => (
                    <StyledTableRow key={transaction.id}>
                      <StyledTableCell>{transaction.id}</StyledTableCell>
                      <StyledTableCell>{transaction.date}</StyledTableCell>
                      <StyledTableCell>{transaction.time}</StyledTableCell>
                      <StyledTableCell>
                        {transaction.transactionId}
                      </StyledTableCell>
                      <StyledTableCell>{transaction.category}</StyledTableCell>
                      <StyledTableCell>{transaction.amount}</StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Box>
        {totalRecords > 5 && (
          <div className="table_pagination_container">
            <div
              className="pagination-btn-wrapper"
              onClick={handlePreviousPage}
            >
              <img src={LeftArrow} alt="Previous" /> Previous
            </div>
            <div>
              <Pagination
                count={Math.ceil(totalRecords / itemsPerPage)} // Use dynamic page count
                page={currentPage} // Controlled page value
                onChange={(e, value) => setCurrentPage(value)} // Update page on pagination change
                color="primary"
                sx={{
                  '& .MuiPaginationItem-root': {
                    color: '#FFFFFF66', // Default color for other pages
                  },
                  '& .Mui-selected': {
                    // Background for selected page
                    color: 'white', // Text color for selected page
                  },
                }}
              />
            </div>
            <div className="pagination-btn-wrapper" onClick={handleNextPage}>
              Next <img src={RightArrow} alt="Next" />
            </div>
          </div>
        )}
      </Container>
    </StyledBgContainer>
  );
};

export default ConsumerDashboard;
